export default {
    id: 0,
    name: "Blank Page",
    state: 1,
    image: "",
    icon: 'mdi-plus',
    blocks: []
}
